import AppEncyclopediaHeader from '../app-encyclopedia-header'
import AppEncyclopediaList from '../app-encyclopedia-list'
import AppEncyclopediaPagination from '../app-encyclopedia-pagination'
import AppFavManager from '../app-fav-manager/'

export default
{
    components:
    {
        AppEncyclopediaHeader,
        AppEncyclopediaList,
        AppEncyclopediaPagination,
        AppFavManager
    },

    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            isListActive: false
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
    },

    mounted()
    {
        this.$content = this.$el.querySelector('.js-content')

        this.onResize()
        this.$emit('page:ready')
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods:
    {
        onResize()
        {
            this._height = this.$content.offsetHeight

            if(this._height > this.$root.window.height - 100)
            {
                this.$el.classList.add('is-too-tall')
            }
            else
            {
                this.$el.classList.remove('is-too-tall')
            }

            console.log('_height', this._height)
        },

        onToggleList()
        {
            this.isListActive = !this.isListActive
            this.$el.classList.toggle('is-list-active')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-encyclopedia-coming-soon/script.js